<div class="body" #body>

    <div class="segment" [class.clickable]="enableNavigation" (click)="navigateToRoot()">Root</div>

    <ng-container *ngFor="let segment of (relativePathArray$|async); let i = index">

        <mat-icon>
            chevron_right
        </mat-icon>

        <div class="segment" [class.clickable]="enableNavigation" (click)="segmentClick(i)">
            {{segment}}
        </div>
        
    </ng-container>
    
</div>